import { BsInstagram, BsLinkedin } from "react-icons/bs";

export interface SocialLink {
  id: string;
  label: string;
  href: string;
  icon: React.ElementType;
}

export const socialLinks: SocialLink[] = [
  {
    id: "instagram",
    label: "Instagram profile",
    href: "https://www.instagram.com/_mega1411/",
    icon: BsInstagram 
  },
  {
    id: "linkedin",
    label: "LinkedIn profile",
    href: "https://www.linkedin.com/in/youssef-abdelmaged-8b6a791bb/",
    icon: BsLinkedin 
  }
];


